import axiosCall from './axiosCall';

export const getAddressAutoComplete = async (query: string, countryCode: string) => {
  try {
    const urlFriendlyQuery = query.replace(/\s/g, '+');
    const result = await axiosCall({
      url: `${process.env.REACT_APP_BASE_URL}v1/location/autocomplete?address=${urlFriendlyQuery}${
        countryCode ? `&country=${countryCode?.toLowerCase?.()}` : ''
      }`,
      method: 'GET',
      headers: {
        token: localStorage.getItem('token'),
      },
    });

    if (result?.data?.data) {
      const options = result?.data?.data?.map((el: any) => ({
        value: el.description,
        label: el.description,
        id: el.place_id,
      }));
      return options;
    }
    return [];
  } catch (error) {
    return [];
  }
};

export const getPlaceDetails = async (placeId: string) => {
  try {
    const result = await axiosCall({
      url: `${process.env.REACT_APP_BASE_URL}v1/location/address-details`,
      method: 'POST',
      data: {
        placeId,
      },
      headers: {
        token: localStorage.getItem('token'),
      },
    });

    if (result?.data?.data) {
      const output = result?.data?.data;

      const data = {
        postalCode: output?.address_components?.find((el: any) => el.types.includes('postal_code'))
          ?.long_name,
        city: output?.address_components?.find((el: any) => el.types.includes('locality'))
          ?.long_name,
        state: output?.address_components?.find((el: any) => el.types.includes('administrative_area_level_1'))?.long_name,
      };

      return data;
    }
    return {};
  } catch (error) {
    return {};
  }
};
